import type {
  InterventionDetail,
  InterventionDetailMeta,
} from "./intervention.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetIntervention = (
  interventionId?: number | string,
  options?: UseGetOptions<InterventionDetail, InterventionDetailMeta>
) => {
  const { data, meta, ...queryResult } = useGet<
    InterventionDetail,
    InterventionDetailMeta
  >("interventions", interventionId, options);

  return {
    intervention: data,
    context: meta?.context,
    ...queryResult,
  };
};
